import { render, staticRenderFns } from "./DialogFooter.vue?vue&type=template&id=7b521135&scoped=true&"
import script from "./DialogFooter.vue?vue&type=script&lang=js&"
export * from "./DialogFooter.vue?vue&type=script&lang=js&"
import style0 from "./DialogFooter.vue?vue&type=style&index=0&id=7b521135&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b521135",
  null
  
)

export default component.exports